import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';

@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [CommonModule, TranslateModule, FeatherModule],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss'
})
export class NoDataComponent {
  /**
   * When true, the bordered card fills the parent height; only the inner message uses
   * position sticky so it stays in view while the page scrolls (e.g. beside a tall tree).
   */
  @Input() centerInViewport = false;

  @HostBinding('class.no-data--center-in-viewport')
  get centerInViewportClass(): boolean {
    return this.centerInViewport;
  }

  /**
   * When true (default), the host does not flex-grow or use height:100%; it sizes like a normal
   * block with a min-height floor (--no-data-compact-min-block in SCSS). Set false to fill the
   * parent column (category panel, etc.).
   */
  @Input() compact = true;

  @HostBinding('class.no-data--compact')
  get compactClass(): boolean {
    return this.compact;
  }

  @Input() titleKey?: string;
  @Input() subtitleKey?: string;
  @Input() title?: string;
  @Input() subtitle?: string;

  /** Extra top padding when passed-in copy is long (translation-only defaults are unchanged). */
  get hasLongCopy(): boolean {
    const titleLen = this.title?.length ?? 0;
    const subtitleLen = this.subtitle?.length ?? 0;
    return titleLen + subtitleLen > 100;
  }
}
